import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const TradeStyles = makeStyles((theme: Theme) =>
  createStyles({
    paperContainer: {
      width: "95%",
      position: "absolute" as "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      borderRadius: "16px",
      padding: "24px",
      [theme.breakpoints.up("md")]: {
        left: "calc(100vw - 45%)",
        width: "550px",
      },
    },
    link: {
      textDecoration: "inherit",
      margin: 0,
      color: "#fc4c4c",
      fontWeight: 600,
      fontSize: "22px",
      lineHeight: 1.5,
    },
    label: {
      fontSize: "14px",
      fontWeight: "bold",
      whiteSpace: "nowrap",
      width: "auto",
      color: "#7B858B",
    },
    maxLabel: {
      fontSize: "14px",
      fontWeight: "bold",
      color: "#7B858B",
      cursor: "pointer",

      textDecoration: "underline",
      "&:hover": {
        color: theme.palette.primary.main,
      },
    },
    inputStyles: {
      fontSize: "28px",
      padding: 0,
      fontWeight: theme.typography.fontWeightMedium,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      width: "100%",
    },
    placeOrderButton: {
      minHeight: "54px",
      background: theme.palette.secondary.main,
      borderRadius: "25px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "#fff",
      textTransform: "inherit",
      marginTop: "14px",
      "&:hover": {
        backgroundColor: "#fff",
        color: "#000",
      },
      "&:disabled": {
        backgroundColor: "lightGrey",
      },
    },
    ArrowDown: {
      position: "absolute",
      padding: "5px",
      background: "#E5E7E8",
      color: theme.palette.primary.main,
      borderRadius: "13px",
      fontSize: "3rem",
      top: -25,
      border: "2px solid #E5E7E8",
      [theme.breakpoints.down(420)]: {
        display: "none",
      },
    },
    box: {
      display: "flex",
      backgroundColor: "primary.main",
      justifyContent: "center",
      position: "relative",
      background: theme.palette.primary.main,
    },
    addAnoterButton: {
      borderRadius: "15px",
      minHeight: "50px",
      background: theme.palette.secondary.main,
      border: "none",
      textTransform: "capitalize",
      "&:hover": {
        backgroundColor: "#fff",
        color: "#000",
      },
    },
    messageContainer: {
      display: "flex",
      padding: "24px 16px 16px",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "16px",
      alignSelf: "stretch",
      borderRadius: "10px",
      background: theme.palette.secondary.contrastText,
    },
    messageContainerText: {
      alignSelf: "stretch",
      color: "#002035",
      textAlign: "center",
      fontFamily: "Roobert",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "16px",
    },
    messageContainerBroker: {
      alignSelf: "stretch",
      color: "#002035",
      textAlign: "right",
      fontFamily: "Roobert",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "16px",
    },
    description: {
      paddingBottom: "14px",
    },
    title: {
      fontWeight: "bold",
      fontSize: "22px",
      marginBottom: "12px",
    },
    subtitle: {
      fontSize: "16px",
      marginBottom: "16px",
      fontWeight: theme.typography.fontWeightRegular,
      color: theme.palette.text.secondary,
    },
    field: {
      width: "90%",
      fontSize: "50px",
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    fieldWrapper: {
      border: "1px solid #e0e0e0",
      backgroundColor: "#fafafa",
      color: "#000",
      borderRadius: "25px",
      justifyContent: "center",
      alignItems: "center",
      display: "flex",
      minHeight: "84px",
    },
    dropdown: {
      borderRadius: "50px",
      width: "142px",
      fontWeight: "bold",
      background: theme.palette.primary.main,
      color: "#fff",
      height: "40px",
      boxShadow: "0px 2px 2px 1px rgba(40, 1, 1, 0.25)",
      border: "none",
      "&:hover": {
        backgroundColor: theme.palette.common.white,
        color: "#fff",
        border: "none",
      },
      [theme.breakpoints.down("md")]: {
        width: "80%",
      },
      [theme.breakpoints.down(450)]: {
        width: "100%",
      },
    },
    container: {
      display: "flex",
      flexDirection: "column",
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      padding: "25px",
      borderRadius: "15px",
      height: "100%",
      [theme.breakpoints.up("md")]: {
        boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;",
        padding: "30px",
        borderRadius: "30px",
      },
    },
    titleB: {
      color: theme.palette.text.primary, //text color
      fontSize: "28px",
      fontWeight: theme.typography.fontWeightBold,
      textTransform: "capitalize",
      display: "flex",
      justifyContent: "start",
      paddingTop: "10px",
      [theme.breakpoints.down("sm")]: {
        fontSize: "30px",
        paddingTop: "0px",
      },
      [theme.breakpoints.down(400)]: {
        fontSize: "28px",
      },
    },
    titleA: {
      color: theme.palette.secondary.main, //text color
      fontSize: "28px",
      fontWeight: theme.typography.fontWeightBold,
      textTransform: "initial",
      display: "flex",
      justifyContent: "start",
      paddingTop: "10px",

      [theme.breakpoints.down("sm")]: {
        fontSize: "30px",
        paddingTop: "0px",
      },
      [theme.breakpoints.down(400)]: {
        fontSize: "28px",
      },
    },
    customBreakPoint: {
      [theme.breakpoints.down(450)]: {
        fontSize: "14px",
      },
    },
  }),
);
